module.exports = __webpack_public_path__ + "static/media/s_nor_04.360d06dd.png";